const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

export const extractUtmParams = (query = {}) => UTM_KEYS.reduce((params, key) => {
  if (typeof query[key] === 'string' && query[key]) {
    params[key] = query[key];
  }

  return params;
}, {});
